import clsx from 'clsx';
import { Button } from '@/components/button';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './review-resubmit-sticky-bar.module.css';

interface ReviewResubmitStickyBarProps {
  onResubmit: () => void;
  loading?: boolean;
}

export function ReviewResubmitStickyBar({ onResubmit, loading }: ReviewResubmitStickyBarProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.stickyBar} data-testid="review-resubmit-sticky-bar">
      <p className={clsx('semibold', styles.disclaimer)}>{t('visit.review.stickyDisclaimer')}</p>
      <Button color="accent" onClick={onResubmit} loading={loading}>
        {t('visit.review.confirmAndResubmitVisit')}
      </Button>
    </div>
  );
}
